import { tns } from "tiny-slider"

export default class Utility {
    constructor(container) {

        if (!container) return;

        const theCarouselContainer = container.querySelector('.references-kontent');
        if (theCarouselContainer &&
            theCarouselContainer.querySelectorAll('.item').length > 1 &&
            !theCarouselContainer.classList.contains('tns-slider')
        ) {
            tns({
                container: container.querySelector('.references-kontent'),
                mouseDrag: true,
                autoplay: false,

                nav: false,
                controls: true,
                controlsText: ['', ''],
                items: 1,
                slideBy: 1

            });
        }

    }
}

